import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { FullCardListProps } from "./types";
import { EntryOptions, PropertyDefinition, PropertyMappingType, } from "app/library/layout-builder";
import { MetaTypeEnum } from "app/shared";

import { ImageChildrenDefinitions } from 'components/cms/definitions';

export class FullCardListDefinitions extends CmsReactComponent<FullCardListProps> {
    static schemaName = "full-card-list";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "cards",
            description: "Kart List Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [
                    {
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        name: "integrationId",
                        text: "Entegrasyon Kimliği",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        name: "title",
                        text: "Başlık",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.String,
                        },
                        name: "subtitle",
                        text: "Alt Başlık Ör:(Opera Binası, Müzikal)",
                    },
                    {
                        mapping: {
                            type: PropertyMappingType.Html,
                        },
                        name: "description",
                        text: "Açıklama",
                    },
                    {
                        name: "image",
                        mapping: {
                            type: PropertyMappingType.ParentObject,
                            children: ImageChildrenDefinitions,
                        },
                        description: "Kart Resimleri",
                    },
                ],
            },
            group: {
                key: "data",
                title: "Kart Verileri",
                withObject: false,
            }
        },
        {
            name: "width",
            text: "Genişlik",
            description: "Kart Görsel Genişliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "height",
            text: "Yükseklik",
            description: "Kart Görsel Yüksekliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: false,
            allowedTypes: [],
        },
        mappingFields: [
            {
                name: "integrationId",
                text: "Entegrasyon Kimliği",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "title",
                text: "Card Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Dropdown],
            },
            {
                name: "subtitle",
                text: "Card Alt Başlığı",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Dropdown],
            },
            {
                name: "description",
                text: "Card Açıklaması",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Editor],
            },
            {
                name: "image",
                text: "Card Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "anchor",
                text: "Card Link",
                types: [MetaTypeEnum.Link],
            },
        ],
    };
}
